import { Box, Stack } from "@mui/material";
import { ReactComponent as IconPlayButton } from "assets/images/square-buttons/video-play.svg";

type VideoBlockProps = {
  thumbnail: string;
  youtubeLink: string;
  children: JSX.Element;
};

const VideoBlock: React.FC<VideoBlockProps> = ({ thumbnail, youtubeLink, children }) => {
  return (
    <Stack direction={"row"} className="greenBox" gap={1.75} mb={"30px"}>
      <Box className="video-thumbnail">
        <a target={"_blank"} href={youtubeLink} rel="noreferrer">
          <img src={thumbnail} height="104" />
          <IconPlayButton />
        </a>
      </Box>
      <Box>
        <Stack>{children}</Stack>
      </Box>
    </Stack>
  );
};

export default VideoBlock;
